import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import MediaRemove from './media-remove'
import MediaPreviewModal from 'pages/widgets/form/media-preview'
import MediaLoading from './media-loading'

const MediaPreview = styled.div`
  width: 50%;
  padding-top: 50%;
  position: relative;

  .br-media-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    padding: 8px;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: 15px;
    cursor: zoom-in;
  }
`

const MediaError = styled.div`
  font-size: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: cover;
  position: absolute;
  top: 5px;
  left: 5px;
  bottom: 5px;
  right: 5px;
  border-radius: 4px;
  background: #bfcad1;
  color: #fff;
  cursor: default !important;
`

class MediaThumbnail extends Component {
  constructor (props) {
    super(props)

    this.state = { id: '' }

    this.removeMedia = this.removeMedia.bind(this)
    this.showMediaPreview = this.showMediaPreview.bind(this)
    this.closeMediaPreview = this.closeMediaPreview.bind(this)
  }

  removeMedia (e) {
    e.stopPropagation()
    const { removeMedia, id } = this.props
    removeMedia(id)
  }

  showMediaPreview (e) {
    e.stopPropagation()

    this.setState({ id: this.props.id })
  }

  closeMediaPreview () {
    this.setState({ id: '' })
  }

  render () {
    const { type, name, id, data } = this.props

    switch (type) {
      case 'image':
      case 'gif':
        return (
          <MediaPreview className='br-media-preview'>
            <img
              className='br-media-thumbnail'
              onClick={this.showMediaPreview}
              id={id}
              src={data}
              alt={name}
            />
            <MediaRemove removeMedia={this.removeMedia} />
            <MediaPreviewModal
              id={this.state.id}
              type={type}
              name={name}
              data={data}
              close={this.closeMediaPreview}
            />
          </MediaPreview>
        )
      case 'video':
        return (
          <MediaPreview className='br-media-preview'>
            <video
              className='br-media-thumbnail'
              onClick={this.showMediaPreview}
              id={id}
              src={data}
              alt={name}
            />
            <MediaRemove removeMedia={this.removeMedia} />
            <MediaPreviewModal
              id={this.state.id}
              type={type}
              name={name}
              data={data}
              close={this.closeMediaPreview}
            />
          </MediaPreview>
        )
      case 'loading':
        return (
          <MediaPreview className='br-media-preview'>
            <MediaLoading className='br-media-loading'>
              <div className='lds-ellipsis'>
                <div />
                <div />
                <div />
                <div />
              </div>
            </MediaLoading>
          </MediaPreview>
        )
      case 'error':
        return (
          <MediaPreview className='br-media-preview'>
            <div className='br-media-error'>
              <MediaError className='br-media-error'>
                <i className='fa fa-exclamation' />
              </MediaError>
            </div>
            <MediaRemove removeMedia={this.removeMedia} />
          </MediaPreview>
        )
      default:
        return null
    }
  }
}

MediaThumbnail.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  data: PropTypes.string,
  removeMedia: PropTypes.func
}

export default MediaThumbnail



// WEBPACK FOOTER //
// ./src/pages/widgets/form/tweet-input/media/media-thumb.js